/*
 * @Author: 赛罗
 * @Date: 2024-01-26 09:06:20
 * @LastEditors: 赛罗
 * @LastEditTime: 2024-01-30 10:07:49
 * @FilePath: \big-screen-vue-datav\src\main.js
 * @Description: 
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

//引入echart
//4.x 引用方式
import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//引入vue-grid-layout
import { GridLayout, GridItem } from 'vue-grid-layout'
Vue.component('grid-layout',GridLayout);
Vue.component('grid-item',GridItem);
//批量注册自定义组件
import customComponents from '@/plugins/components.js'
Vue.use(customComponents);

// 全局注册
Vue.use(ElementUI);
Vue.component('icon', Icon);
Vue.use(dataV);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
